// libs
import { ErrorCode, FileRejection } from 'react-dropzone'
// utils
import { ALLOWED_MIME_TYPES, HTTP_SCHEME_REGEX, normalizeLink } from 'utils/index'

const SIZE_UNITS = ['B', 'KB', 'MB', 'GB']
const HTTP_PROTOCOLS = ['http:', 'https:']

export const DROPZONE_ACCEPT = ALLOWED_MIME_TYPES.reduce((acc, mime) => ({ ...acc, [mime]: [] }), {})

export const getRejectionMessage = (rejections: FileRejection[]) =>
  rejections.length > 1 || rejections[0]?.errors[0]?.code === ErrorCode.TooManyFiles
    ? 'Only one file can be attached'
    : 'This file type is not supported'

export const getFileExtension = (fileName?: string) => {
  const extension = fileName?.includes('.') ? fileName.split('.').pop() : ''

  return extension?.toUpperCase() || 'FILE'
}

export const formatFileSize = (bytes?: number) => {
  if (!bytes) {
    return ''
  }

  const unitIndex = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), SIZE_UNITS.length - 1)
  const value = bytes / Math.pow(1024, unitIndex)

  return `${unitIndex ? value.toFixed(1) : value} ${SIZE_UNITS[unitIndex]}`
}

// links are opened through normalizeLink, so only http(s) links make sense; a bare value must look like a domain,
// single-label intranet hosts need an explicit http(s):// scheme
export const isValidLink = (value: string) => {
  const trimmed = value.trim()

  // empty values and spaces in the host make URL throw, spaces in the path are valid and get encoded
  try {
    const { protocol, hostname, username } = new URL(normalizeLink(trimmed))

    return HTTP_PROTOCOLS.includes(protocol) && !username && (hostname.includes('.') || HTTP_SCHEME_REGEX.test(trimmed))
  } catch {
    return false
  }
}
